export enum DeviceStatusReferenceType {
    practitionerId = 'practitionerId',
    processId = 'processId',
}
